<template>
  <div class="page-container content-430">
    <div class="table-title-special-430">
      <div class="box-title-430">
        {{ routeTitle }}
      </div>
      <div class="operation-430">
        <SearchBlock
          :class-time-table-go-detail="true"
          :prop-school-id="schoolId"
          @handleExportMore="handleExport"
        >
        </SearchBlock>
      </div>
    </div>
    <div class="table-box">
      <Table
        :loading="loadingTimeTable"
        border
        :columns="timeTableColumn"
        :data="studentTimeTable"
        height="700"
      >
        <template slot="gradeName" slot-scope="{ row }">
          <div>{{ row.gradeName }}{{ row.className }}</div>
        </template>
        <template slot="parentPhones" slot-scope="{ row }">
          <div>{{ row.parentPhones ? row.parentPhones.join(',') : '' }}</div>
        </template>
        <template
          v-for="(item, index) in weekList"
          :slot="'dayOfWeek' + item.value"
          slot-scope="{ row }"
        >
          <div :key="index" class="time-item-box">
            <div
              v-for="(x, y) in row[item.rowKey]"
              :key="y"
              class="time-item"
              @click="handleShowModal(x.classroomId)"
            >
              <span>{{ x.classroomName }}</span>
              <span>{{ x.classTimeBegin | formatTime }}-{{
                x.classTimeEnd | formatTime
              }}</span>
            </div>
          </div>
        </template>
      </Table>
    </div>
    <div>
      <Modal
        v-model="showExportModal"
        title="正在导出"
        @on-cancel="handleCancelExport"
      >
        <Progress :percent="percent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间
        <div slot="footer">
          <Button @click="handleCancelExport">取消</Button>
        </div>
      </Modal>
    </div>
    <CourseTypeModal
      ref="CourseTypeModalRef"
      @on-finish="handleSelectSubmit"
    ></CourseTypeModal>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { weekList } from '@/utils/dictionary.js';
import { timeToStr } from '@/utils/utils.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import { tableColumnsWidth, key, slot } from '@/assets/js/resetTableStyle';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import CourseTypeModal from './assets/components/CourseTypeModal.vue';
import commonApi from '@/request/common/index.js';
let IntervalId;
export default {
  components: {
    SearchBlock,
    CourseTypeModal
  },
  filters: {
    formatTime(time) {
      return timeToStr(time);
    }
  },
  props: {
    paramsSchoolId: {
      type: String,
      default: ''
    },
    classIdStr: {
      type: String,
      default: ''
    },
    yearCode: {
      type: String || Number,
      default: ''
    },
    termCode: {
      type: String || Number,
      default: ''
    }
  },
  data() {
    return {
      showExportModal: false,
      percent: 0, // 进度条,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      timeTableColumn: [
        key('序号', null, tableColumnsWidth.type2, {
          type: 'index',
          fixed: 'left'
        }),
        key('学生名称', 'studentName', tableColumnsWidth.type2),
        slot('年级班级', 'gradeName', tableColumnsWidth.type3),
        slot('家长手机号码', 'parentPhones', tableColumnsWidth.type3),
        slot('周一', 'dayOfWeek1', tableColumnsWidth.default),
        slot('周二', 'dayOfWeek2', tableColumnsWidth.default),
        slot('周三', 'dayOfWeek3', tableColumnsWidth.default),
        slot('周四', 'dayOfWeek4', tableColumnsWidth.default),
        slot('周五', 'dayOfWeek5', tableColumnsWidth.default)
      ],
      studentTimeTable: [],

      selectData: {},
      schoolName: '', // 学校名称
      selectClassroomId: '', // 选中的课班
      personId: '', // 选中的学生id
      personName: '', // 选中的学生姓名
      portOrg: -1, // 处于哪个端
      schoolId: '',

      downloadUrl: '', // 下载地址
      downloadToken: '',
      userIp: '', // 用户ip
      loadingTimeTable: false,
      typeList: [11, 12, 13, 14, 15, 23], // 课程类型-默认
      placeFlag: '1', // 是否包含上课场地
      waitRefundShow: '1'// 1=不显示退款待审核课程
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle']),
    params() {
      return {
        schoolId: this.paramsSchoolId,
        classIdStr: this.classIdStr,
        yearCode: this.yearCode,
        termCode: this.termCode
      };
    },
    weekList() {
      return weekList.map(item => {
        return {
          ...item,
          rowKey: `dayOfWeek${item.value}`
        };
      });
    }
  },
  created() {
    console.log('this.$route.query:', this.$route.query);
    if (this.$route.query.schoolId) {
      this.params = this.$route.query;
    }
    this.getUserIpAddress();
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.schoolId = this.portOrg === 2 ? this.userInfo.orgId : '';
    this.schoolName = this.userInfo.orgName;

    // if (this.portOrg === 2) {
    this.getstudentTimeTableList();
    // }
  },
  methods: {
    // 获取用户IP
    async getUserIpAddress() {
      commonApi.getIpAddr().then(res => {
        this.userIp = res.message;
      });
      // this.userIp = getUserIp();
    },
    // 获取详情数据
    async getstudentTimeTableList() {
      const params = { ...this.params, classIds: this.params.classIdStr };
      this.loadingTimeTable = true;

      const res = await courseSchedulCenter.getCourseClassDirectionDetail(
        params
      );
      this.loadingTimeTable = false;
      if (res.status == 200) {
        this.studentTimeTable = res.message.list.map(item => {
          if (item.details.length) {
            item.details.forEach(x => {
              // 去重掉相同的课程
              const classroomIdObj = {};
              const courseArr = x.courseDetails.reduce((nowItem, nextItem) => {
                classroomIdObj[nextItem.classroomId]
                  ? ''
                  : (classroomIdObj[nextItem.classroomId] =
                    true && nowItem.push(nextItem));
                return nowItem;
              }, []);
              item[`dayOfWeek${x.dayOfWeek}`] = courseArr;
            });
          }

          return item;
        });

        this.pageInfo.total = Number(res.message.total);
      }
    },
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    async handleExportMore() {
      this.percentShow();
      this.showExportModal = true;
      console.log('params:', this.params);
      const res = await courseSchedulCenter.courseClassDirectionExport(
        this.params
      );
      this.classId = '';
      if (res.data.type === 'application/vnd.ms-excel') {
        this.$Message.success('导出成功');
        clearInterval(IntervalId);
        this.percent = 100;
        setTimeout(() => {
          this.showExportModal = false;
        }, 500);
        downLoadByBlob(res);
      } else {
        clearInterval(IntervalId);
        this.percent = 60;
        setTimeout(() => {
          this.showExportModal = false;
        }, 500);
        this.$Message.error('导出失败');
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      const params = {
        fileId: [fileId],
        type: 2
      };
      const res = await cateringAdmin.getDownloadtoken(params);
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
        this.downloadToken = res.message.token;
      }
    },
    // 获取任务Id
    getTaskId() {
      return new Promise(async(resolve, reject) => {
        try {
          const params = {
            // ...this.params,
            // classIds: this.params.classIdStr,
            // addr: this.userIp
            ...this.params,
            classIds: [this.params.classIdStr],
            addr: this.userIp,
            placeFlag: this.placeFlag != '1',
            typeList: this.typeList
          };
          if (this.waitRefundShow === '1') {
            params.waitRefundShow = this.waitRefundShow;
          }
          const res = await courseSchedulCenter.getTaskIdApi(params);
          if (res.status === 200) {
            resolve(res.message);
          } else {
            reject(res.message);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    // 导出
    handleExport() {
      this.$refs.CourseTypeModalRef.getExReset();
      this.$refs.CourseTypeModalRef.handleShow();
    },
    // 导出弹窗确定
    async handleExSubmit() {
      const taskId = await this.getTaskId();
      try {
        var source = new EventSource(
          `${process.env.VUE_APP_EVENT_SOURCE}/sse/subscribe?id=${taskId}`
        );
        this.percentShow();
        this.showExportModal = true;
        setTimeout(async() => {
          const params = {
            ...this.params,
            classIds: [this.params.classIdStr],
            addr: this.userIp,
            placeFlag: this.placeFlag != '1',
            typeList: this.typeList
          };
          if (this.waitRefundShow === '1') {
            params.waitRefundShow = this.waitRefundShow;
          }
          const res = await courseSchedulCenter.courseClassDirectionExport(
            params
          );
          this.classId = '';
        }, 3000);
        // 回调
        source.onopen = event => {
          console.log(event, '通道打开=====');
        };
        source.onmessage = async event => {
          console.log('event.data', event.data);
          this.tipsIndex = Math.round(Math.random());
          const { resultContent, taskStatus } = JSON.parse(event.data);
          //  0 待处理 1 处理中 2处理成功 9处理异常
          if (taskStatus === 2) {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              if (!this.classId) {
                this.showSelectExportModal = false;
              }
            }, 500);
            const infoData = JSON.parse(resultContent)[0];
            const { fileId, name } = infoData;
            // await this.getDownloadtoken();
            // downloadReport(this.downloadUrl, { fileId, token: this.downloadToken });
            // return;
            const downloadElement = document.createElement('a');
            await this.getDownloadtoken(fileId);
            const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.download = name; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            source.close();
          }
          if (taskStatus === 9) {
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error('导出失败');
          }
        };
      } catch (err) {
        clearInterval(IntervalId);
        this.percent = 60;
        setTimeout(() => {
          this.showExportModal = false;
        }, 500);
        this.$Message.error('导出失败');
      }
    },
    // 导出取消
    handleCancelExport() {
      this.showExportModal = false;
    },
    // 展示弹窗
    handleShowModal(id) {
      this.selectClassroomId = id;
      this.$nextTick(() => {
        this.$refs.courseDetailModal.open();
      });
    },
    // 导出-选择课程分类-确定
    handleSelectSubmit(info) {
      // const reData = this.$refs.courseTypesRef.getResult();
      this.typeList = info.courseTypesData.typeIds;
      this.placeFlag = info.placeFlag;
      if (this.typeList.length == 0) {
        this.$Message.error('请至少勾选一个班级课程类型');
        return false;
      }
      this.$refs.CourseTypeModalRef.handleHide();
      this.handleExSubmit();
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin-top: 32px;
}
.time-item-box {
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .time-item {
    padding: 8px;
    border-radius: 4px;
    background: rgba(97, 73, 241, 0.1);
    color: #488ffa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    span + span {
      margin-top: 8px;
    }
  }
  .time-item + .time-item {
    margin-top: 24px;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
